import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { NcdclientService } from 'src/app/services/NCD/ncdclient.service';
import { environment } from 'src/environments/environment';
import { AllottesLibraryComponent } from '../allottes-library/allottes-library.component';
import { AlertComponent } from '../../alert/alert.component';
@Component({
  selector: 'app-allottes-library-list',
  templateUrl: './allottes-library-list.component.html',
  styleUrls: ['./allottes-library-list.component.css']
})
export class AllottesLibraryListComponent implements OnInit {
  isSearchDivVisible = false;
  dtElement: DataTableDirective;
  dtAllotteesList: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  dtnotInsertdata: DataTables.Settings = {};
  dtnotInsertdataTrigger: Subject<any> = new Subject();

  @Input('issueId') issueId: any;
  // @Input('issueDetails') issueDetails: any;

  ncdAllotteeMasterList: any;
  allotteeDetails: any;
  allotteeId: any;
  deleteAllotteeId: any;

  // Search variables
  investorCodeModel: any = '';
  nameModel: any = '';
  investorCategoryModel: any = '';
  investorSubcategoryModel: any = '';
  dpTypeModel: any = '';
  dpIdModel: any = '';
  InvestorCodesList: any = [];
  fileSizeError: boolean;
  isUploadNotValid: boolean;
  fileExtension: any;
  fileExtensionError: boolean;
  filesToUpload: any;
  notinserteddata: any;
  investorCodeToDelete: any;


  constructor(private ncdClientService: NcdclientService,
    private modalService: NgbModal, private alert: AlertComponent) { }

  ngOnInit() {
    this.dtAllotteesList = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      autoWidth: false,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [21] }, { className: "hide_col", targets: [0, 3, 4, 5, 6, 7, 8, 9, 11, 12, 15, 16, 17] }],
      // columnDefs: [{ orderable: false, targets: [4] }, { className: "hide_col", targets: [5,6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'NCD-Allottee Library List',
          title: 'NCD-Allottee Library List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
            // columns: [0, 1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92]
          }
        }
      ]
    };


    this.dtnotInsertdata = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Upload Again',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Not Inserted Records',
          extend: 'excel',
          title: '',
          exportOptions: {
            columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          },
        }
      ]

    }

    this.getExistingAllotteesInvestorCodeList();
    this.getMasterAllotteesList({ isSearch: false });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  getExistingAllotteesInvestorCodeList() {
    this.InvestorCodesList = [];
    this.ncdClientService.getExistingAllotteesList()
      .subscribe(response => {
        if (response.status == 0) {
          var self = this;
          response.data.forEach(function (o) {
            self.InvestorCodesList.push(o.investorCode);
          });
        } else {
          // this.alert.error(response.message);
        }
      });
  }

  getMasterAllotteesList(object) {
    this.ncdAllotteeMasterList = [];
    $("#allotteesListTable").DataTable().destroy();
    this.ncdClientService.getAllAlloteesListData(object).subscribe((allotteList: any) => {
      this.ncdAllotteeMasterList = allotteList.data;
      // console.log("this.ncdAllotteeMasterList+++++++++++++", this.ncdAllotteeMasterList);
      this.dtTrigger.next();
    })
  }

  async loadNcdAllotteesByID(id, status) {
    // this.deleteAllotteeId = id;
    this.allotteeId = id;
    var self = this;

    this.getAllotteeDetails(function (error, res) {
      const modalRef = self.modalService.open(AllottesLibraryComponent, {
        backdrop: 'static',
        size: "lg"
      })

      modalRef.componentInstance.allotteeId = id;
      modalRef.componentInstance.allotteeStatus = status;
      modalRef.componentInstance.allotteeDetails = self.allotteeDetails;

      modalRef.result.then(resp => {
        self.getMasterAllotteesList({ isSearch: false });
        self.getExistingAllotteesInvestorCodeList();
      }, (error) => {
      })
    });
  }

  confirmDelete(id, investorCode) {
    // console.log("id +++++++++ ",id);
    // this.deleteAllotteeId = id;
    this.allotteeId = id;
    this.investorCodeToDelete = investorCode;
    this.getAllotteeDetails(function (error, res) {
      // console.log(error,res)
    });
    $("#confirmDeleteAllottee").modal('toggle');
  }

  getAllotteeDetails(callback) {
    if (this.allotteeId != null) {
      this.ncdClientService.getAlloteeDetails(this.allotteeId)
        .subscribe(response => {
          if (response.status == 0) {
            this.allotteeDetails = response.data;
            callback(null, true)
          } else {
            this.alert.error(response.message);
            callback(true, null)
          }
        });
    } else {
      callback(true, null)
    }

  }

  deleteNcdAllotteesFromMaster() {

    this.ncdClientService.deleteCompanySpecificAllottees(this.allotteeDetails._id, this.investorCodeToDelete)
      .subscribe(response => {
        if (response.status == 0) {
          $("#allotteesListTable").DataTable().destroy();
          this.getMasterAllotteesList({ isSearch: false });
          this.getExistingAllotteesInvestorCodeList();
          this.alert.success(response.message);
        } else {
          this.alert.error(response.message);
        }
      });
  }

  doAdvSearch() {

    if (this.investorCodeModel == '' && this.nameModel == '' && this.investorCategoryModel == '' && this.investorSubcategoryModel == '' && this.dpTypeModel == '' && this.dpIdModel == '') {
      this.alert.success("Fill atleast one search field");
    } else {

      var searchnewFieldObject = {
        'investorCode': this.investorCodeModel,
        'name': this.nameModel,
        'investorCategory': this.investorCategoryModel,
        'investorSubcategory': this.investorSubcategoryModel,
        'dpType': this.dpTypeModel,
        'dpId': this.dpIdModel,
        'isSearch': true
      }

      $("#allotteesListTable").DataTable().destroy();
      this.getMasterAllotteesList(searchnewFieldObject);
    }
  }

  clearAdvSearch() {
    this.investorCodeModel = '';
    this.nameModel = '';
    this.investorCategoryModel = '';
    this.investorSubcategoryModel = '';
    this.dpTypeModel = '';
    this.dpIdModel = '';
    $("#allotteesListTable").DataTable().destroy();
    this.getMasterAllotteesList({ isSearch: false });
  }

  allExtensions() {
    return ["csv", "xlsx", "xls", "jpg", "jpeg", "png", "doc", "docx", "txt", "pdf", "ppt", "pptx", "mp4", "apk", "bat", "bin", "cgi", "com", "exe", "jar", "py", "wsf", "aif", "cda", "iff", "mid", "midi", "mp3", "mpa", "wav", "wma", "wpl", "avi", "flv", "h264", "m4v", "mkv", "mov", "mpg", "mpeg", "rm", "swf", "vob", "wmv", "3g2", "3gp", "odt", "msg", "rtf", "tex", "wks", "wps", "wpd", "ods", "xlr", "key", "odp", "pps", "accdb", "dat", "db", "dbf", "log",
      "mdb", "pdb", "sav", "sql", "tar", "bak", "cab", "cfg", "cpl", "cur", "dll", "dmp", "drv", "icns", "ico", "ini", "lnk", "msi", "sys", "tmp", "asp", "aspx", "cer", "cfm", "cgi", "pl", "css", "htm", "html", "js", "jsp", "part", "php", "rss", "xhtml", "ai", "bmp", "gif", "ico", "max", "obj", "ps", "psd", "svg", "tif", "tiff", "3ds", "3dm"];

  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }


  fileChanged($event) {
    if ($event.target.files[0] / (1024 * 1024) > (1024 * 1024)) {
      this.fileSizeError = true;
      this.isUploadNotValid = true;
    } else {
      var count = 0;
      var self = this;
      var allowedExtensions = ["csv", "CSV", "xlsx", "XLSX"];
      var filename = $event.target.files[0].name;
      var checkFilesExtension = filename.toString().split('.').pop();
      // console.log(" checkFilesExtension : ====>  ", checkFilesExtension )
      this.fileExtension = filename.split('.');
      // console.log("fileExtension", this.fileExtension);

      this.fileExtension.forEach(function (value, key) {
        // console.log(key + ': ' + value);
        if (self.isInArray(self.allExtensions(), value)) {
          count++;
        }
      });

      //this.fileExtension = filename.toString().split('.').pop();
      // console.log("filename", filename);


      if (count == 1 && self.isInArray(allowedExtensions, checkFilesExtension)) {
        this.fileExtensionError = false;
        this.fileSizeError = false;
        this.isUploadNotValid = false;
        this.filesToUpload = $event.target.files;
      } else {
        this.fileExtensionError = true;
        this.isUploadNotValid = true;
      }
    }
  }


  // BULK UPLOAD 

  // fileChanged($event) {
  //   console.log('file changed', $event.target.files[0])
  //   if ($event.target.files[0] / (1024 * 1024) > (1024 * 1024)) {
  //     this.fileSizeError = true;
  //     this.isUploadNotValid = true;
  //   } else {
  //     var allowedExtensions = ["csv", "CSV", "xlsx", "XLSX"];
  //     var filename = $event.target.files[0].name;
  //     this.fileExtension = filename.toString().split('.').pop();
  //     console.log("filename", filename);
  //     console.log("fileExtension", this.fileExtension);

  //     if (this.isInArray(allowedExtensions, this.fileExtension)) {
  //       this.fileExtensionError = false;
  //       this.fileSizeError = false;
  //       this.isUploadNotValid = false;
  //       this.filesToUpload = $event.target.files;
  //     } else {
  //       this.fileExtensionError = true;
  //       this.isUploadNotValid = true;
  //     }
  //   }
  // }


  // isInArray(array, word) {
  //   return array.indexOf(word.toLowerCase()) > -1;
  // }

  upload() {
    var file = this.filesToUpload;
    if (file != undefined) {
      this.makeFileRequest(environment.pssServerUrl + "ncdAlloteeMaster/excelFileUplaodForAllottee", [], file).then((result) => {
        $("#fileInput").val('');
        // console.log("result", result)
        this.isUploadNotValid = true;
        if (result['status'] == 0) {

          this.notinserteddata = result['data'];
          $("#CsvUploadtable").DataTable().destroy();
          // console.log(result['data'])
          this.dtnotInsertdataTrigger.next();

          if (_.size(result['data'])) {

            $('#notInsertdata').modal('show');
          }
          else {
            this.alert.success(result['message']);
          }
          this.getMasterAllotteesList({ isSearch: false });
          this.getExistingAllotteesInvestorCodeList();
        } else {
          this.alert.error(result['message']);
          // this.getMasterAllotteesList({ isSearch: false });
        }

      });
    } else {
      console.log("file undefined")
    }
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      for (var i = 0; i < files.length; i++) {
        var newDate = Date.now();
        formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.setRequestHeader('userdetail', this.getUserDetail())
      xhr.setRequestHeader('pssdetail', localStorage.getItem("companyDetails"))
      xhr.send(formData);
    });
  }

  getUserDetail() {
    var user = JSON.parse(localStorage.getItem("user"));
    var resources = JSON.parse(localStorage.getItem("resources"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));
    var resourcesData = resources.filter(function (item) {
      return item.Menu === 'UPSI';
    })[0]

    var upsiAdmin;
    if (resourcesData) {
      upsiAdmin = (resourcesData['Menu']) ? true : false
    } else {
      upsiAdmin = false
    }

    var loginUser = {
      id: user._id,
      firstName: user.FirstName,
      lastName: user.LastName,
      upsiAdmin: upsiAdmin,
      EmailId: user.EmailId,
      companyDetails: companyDetails,
      title: user.Title
    }
    return JSON.stringify(loginUser);
  }

  maskEmail(email: string): string {
    if (email) {
      const [username, domain] = email.split('@');
      return username && domain ? `${username.slice(0, 3)}******@${domain}` : '';
    }
    return '';
  }
}

